import React from 'react';
import LineChart from '.././../containers/Charts/LineChart';
import FinancialInfo from './FinancialInfo/FinancialInfo';
import './StockDetails.css';

const StockCash = ({cashFlow, aspect}) => {
    const operating = {
        labels: cashFlow?.timeBasedSheets[1]?.columnHeadings,
        datasets: [
            {
                data: cashFlow?.timeBasedSheets[1]?.chartData[0]?.values,
                label: cashFlow?.timeBasedSheets[1]?.chartData[0]?.name,
                fill : true,
                backgroundColor: `#71d46d48`,
                borderColor: `#30a02cd2`,
                barThickness: 50,
            }
        ]
    }

    const investing = {
        labels: cashFlow?.timeBasedSheets[1]?.columnHeadings,
        datasets: [
            {
                data: cashFlow?.timeBasedSheets[1]?.chartData[1]?.values,
                label: cashFlow?.timeBasedSheets[1]?.chartData[1]?.name,
                fill : true,
                backgroundColor: `#71d46d48`,
                borderColor: `#30a02cd2`,
            }
        ]
    }

    const financing = {
            labels: cashFlow?.timeBasedSheets[1]?.columnHeadings,
            datasets: [
                {
                    data: cashFlow?.timeBasedSheets[1]?.chartData[2]?.values,
                    label: cashFlow?.timeBasedSheets[1]?.chartData[2]?.name,
                    fill : true,
                    backgroundColor: `#71d46d48`,
                    borderColor: `#30a02cd2`,                   
                }
            ]
    }

    const barOptions = {
        scales: {
            yAxes: [
                {
                    ticks: {
                        beginAtZero: true,
                    },

                }
            ],
            y: {
                ticks: {
                    // Include a dollar sign in the ticks
                    callback: function(value, index, values) {
                        return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumSignificantDigits: 3 }).format(value/10000000) + " Cr";
                        
                    }
                }
            }
        }
    }

    return (
        <div className="mt-4">
            <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                <li className="nav-item btn-sm mx-2" role="presentation">
                    <button className="nav-link finance-link active" id="pills-cabout-tab" data-bs-toggle="pill" data-bs-target="#pills-cabout" type="button" role="tab" aria-controls="pills-cabout" aria-selected="true">
                        <small><small>About</small></small>
                    </button>
                </li>
                <li className="nav-item btn-sm mx-2" role="presentation">
                    <button className="nav-link finance-link" id="pills-operating-tab" data-bs-toggle="pill" data-bs-target="#pills-operating" type="button" role="tab" aria-controls="pills-operating" aria-selected="false">
                        <small><small>Operating</small></small>
                    </button>
                </li>
                <li className="nav-item btn-sm mx-2" role="presentation">
                    <button className="nav-link finance-link" id="pills-investing-tab" data-bs-toggle="pill" data-bs-target="#pills-investing" type="button" role="tab" aria-controls="pills-investing" aria-selected="false">
                        <small> <small>Investing</small> </small>
                    </button>
                </li>
                <li className="nav-item btn-sm mx-2" role="presentation">
                    <button className="nav-link finance-link" id="pills-financing-tab" data-bs-toggle="pill" data-bs-target="#pills-financing" type="button" role="tab" aria-controls="pills-financing" aria-selected="false">
                        <small><small>Financing</small></small>
                    </button>
                </li>
            </ul>
            <div className="tab-content" id="pills-tabContent">
            <div className="tab-pane fade show active" id="pills-cabout" role="tabpanel" aria-labelledby="pills-cabout-tab">
                    <FinancialInfo aspect={aspect}/>
                </div>
                <div className="tab-pane fade" id="pills-operating" role="tabpanel" aria-labelledby="pills-operating-tab">
                    <LineChart data={operating} options={barOptions}/>
                </div>
                <div className="tab-pane fade" id="pills-investing" role="tabpanel" aria-labelledby="pills-investing-tab">
                    <LineChart data={investing} options={barOptions}/>
                </div>
                <div className="tab-pane fade" id="pills-financing" role="tabpanel" aria-labelledby="pills-financing-tab">
                    <LineChart data={financing} options={barOptions}/>
                </div>
            </div>            
        </div>
    )
}

export default StockCash
